<app-dash-widgets></app-dash-widgets>

<div class="graphs-row">
    <app-collection-progress-graph [onDashboard]="true"
                                   [title]="'Invoiced vs. Paid'"></app-collection-progress-graph>

    <app-dash-expense-graph></app-dash-expense-graph>

    <lf-org-bank-account-list></lf-org-bank-account-list>

    <app-dash-payments></app-dash-payments>
</div>
